import { render } from "./CardSetPreview.vue?vue&type=template&id=bcc07b82&scoped=true&ts=true"
import script from "./CardSetPreview.vue?vue&type=script&lang=ts"
export * from "./CardSetPreview.vue?vue&type=script&lang=ts"

import "./CardSetPreview.vue?vue&type=style&index=0&id=bcc07b82&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcc07b82"]])

export default __exports__